<script  lang="ts">
import EntityInitSection from '../../common/entity/EntityInitSection.vue'

export default {
    name: 'IntentionEntityPanelContact',
    extends: EntityInitSection,
    emits: ['updateData'],
}
</script>

<template>
    <FormSection v-if="data" title="Contact" with-borders-color="primary">
        <FormInput
            data-key="contact_name"
            :validation="validation?.contact_name"
            :data
            :validation-rules
            :translation-name
            @update-data="$emit('updateData', { [`contact_name`]: $event })"
        />
        <FormInput
            data-key="contact_email"
            :validation="validation?.contact_email"
            :data
            :validation-rules
            :translation-name
            @update-data="$emit('updateData', { [`contact_email`]: $event })"
        />
        <FormInput
            data-key="contact_phone"
            :validation="validation?.contact_phone"
            :data
            :validation-rules
            :translation-name
            @update-data="$emit('updateData', { [`contact_phone`]: $event })"
        />
    </FormSection>
</template>
